export const buttonLinkClasses = `
  rounded flex flex-row items-center justify-center gap-6 px-4 py-2
  group
  bg-primary
  border-primary
  text-white
  hover:text-primary
  hover:border-2
  hover:border-primary
  hover:bg-white
  hover:fill-white
  transition-all
  fill-primary
  font-bold
  disabled:text-white
  disabled:cursor-not-allowed
  disabled:border-mediumGray
  disabled:bg-mediumGray
  border-2
  text-base
`